import React from "react";
import { IndexRoute, Route } from "react-router";

import App from "./App";
import HomePage from "./home/HomePage";
import ExceptionPage from "./exception/ExceptionPage";
import NietGevondenPage from "./home/NietGevondenPage";

import DossierPage from "./dossier/DossierPage";
import AanvraagPage from "./aanvraag/AanvraagPage";
import AanvraagBevestigingPage from "./aanvraag/AanvraagBevestigingPage";
import ProjectPage from "./project/ProjectPage";
import BovenlokaliteitInfoPage from "./bovenlokaliteitInfo/BovenlokaliteitInfoPage";
import BovenLokaliteitPerDossierPage from "./bovenLokaliteitPerDossier/BovenLokaliteitPerDossierPage";
import BovenLokaliteitPerInfrastructuurPage from "./bovenLokaliteitPerInfrastructuur/BovenLokaliteitPerInfrastructuurPage";
import MinimaleEisenInfoPage from "./minimaleEisenInfo/MinimaleEisenInfoPage";
import MinimaleEisenPerDossierPage from "./minimaleEisenPerDossier/MinimaleEisenPerDossierPage";
import FinancieelPage from "./financieel/FinancieelPage";
import KostenPage from './financieel/kosten/KostenPage';
import KostOpbrengstEditPage from './financieel/kostOpbrengstEdit/KostOpbrengstEditPage';
import OpbrengstenPage from './financieel/opbrengsten/OpbrengstenPage';
import OverzichtPage from './financieel/overzicht/overzichtPage';
import InvesteringenPage from './financieel/investeringen/InvesteringenPage';
import InvesteringEditPage from './financieel/investeringEdit/InvesteringEditPage';
import FinancieringPage from "./financieel/financiering/FinancieringPage";
import FinancierEditPage from "./financieel/financiering/financierEdit/FinancierEditPage";
import MinimaleEisenPerInfrastructuurPage from "./minimaleEisenPerInfrastructuur/MinimaleEisenPerInfrastructuurPage";
import BeoordelingscriteriaBovenlokaalPage from "./criteriaBovenlokaal/BeoordelingscriteriaBovenlokaalPage";
import BeoordelingscriteriaTopsportPage from "./criteriaTopsport/BeoordelingscriteriaTopsportPage";
import IndienenPage from "./indienen/IndienenPage";
import IndienenBevestigingPage from "./indienen/IndienenBevestigingPage";
import InfrastructuurDetailPage from "./infrastructuurDetail/InfrastructuurDetailPage";
import InfrastructuurInDeBuurtDetailPage from "./infrastructuurInDeBuurtDetail/InfrastructuurInDeBuurtDetailPage";

import SimulatieDossierPage from "./simulatiedossier/SimulatieDossierPage";
import SimulatiePerInfrastructuurPage from "./simulatiePerInfrastructuur/SimulatiePerInfrastructuurPage";
import SimulatieResultaatPage from "./simulatieResultaat/SimulatieResultaatPage";
import SimulatieBevestigingPage from "./simulatieBevestiging/SimulatieBevestigingPage";
import SimulatieInfrastructuurDetailPage from "./simulatieInfrastructuurDetail/SimulatieInfrastructuurDetailPage";

import VRProjectPage from "./voortgangsrapport/project/VRProjectPage";
import VRBeoordelingscriteriaPage from "./voortgangsrapport/beoordelingscriteria/VRBeoordelingscriteriaPage";
import VRVerantwoordingPage from "./voortgangsrapport/verantwoording/VRVerantwoordingPage";
import VRIndienenPage from "./voortgangsrapport/indienen/VRIndienenPage";
import VRIndienenBevestigingPage from "./voortgangsrapport/indienen/VRIndienenBevestigingPage";
import * as constants from "../constants/DomainConstants";

import AfgeslotenPage from "./home/AfgeslotenPage";
import TestPage from "./TestPage";

export const getRoutes = (store) => {
	return (
		<div>
			<Route path={store.getState().settings.siteRoot} component={App}>
				<IndexRoute component={HomePage} />
				<Route path="aanvraag/bevestiging" component={AanvraagBevestigingPage} />
				<Route path="aanvraag/nieuw/:type" component={AanvraagPage} />
				<Route path="aanvraag/nieuw" component={AanvraagPage} />
				<Route path="aanvraag/simulatie/:simulatieId" component={AanvraagPage} />
				<Route path="aanvraag/:id" component={AanvraagPage} />
				<Route path="mijndossier/:id" component={DossierPage} />
				<Route path="mijndossier/" component={DossierPage} />
				<Route path="mijndossier" component={DossierPage} />
				<Route path="exception" component={ExceptionPage} />
				<Route path="project/:dossierId" >
					<IndexRoute component={ProjectPage} />
					<Route path="edit/infra/:infrastructuurId" component={InfrastructuurDetailPage} params={{ isNew: false }} />
					<Route path="add/infraRenovatie/:infrastructuurId" component={InfrastructuurDetailPage} params={{ isNew: true }} />
					<Route path="add/infraNieuwbouw" component={InfrastructuurDetailPage} params={{ isNew: true, type: constants.INFRASTRUCTUUR_TYPE.NIEUWBOUW }} />
					<Route path="add/infraRenovatie" component={InfrastructuurDetailPage} params={{ isNew: true, type: constants.INFRASTRUCTUUR_TYPE.RENOVATIE }} />
				</Route>

				<Route path="minimaleeisen/:dossierId">
					<IndexRoute component={MinimaleEisenInfoPage} />
					<Route path="algemeen" component={MinimaleEisenPerDossierPage} />
					<Route path="infrastructuur/:infrastructuurId" component={MinimaleEisenPerInfrastructuurPage} />
				</Route>

				<Route path="financieel/:dossierId">
					<IndexRoute component={FinancieelPage} />
					<Route path="kosten" component={KostenPage} />
					<Route path="opbrengsten" component={OpbrengstenPage} />
					<Route path="overzicht" component={OverzichtPage} />
					<Route path="kostedit/new" component={KostOpbrengstEditPage} params={{ isNew: true, type: constants.KostOpbrengst.KOST }} />
					<Route path="kostedit/:kostOpbrengstId" component={KostOpbrengstEditPage} params={{ isNew: false, type: constants.KostOpbrengst.KOST }} />
					<Route path="opbrengstedit/new" component={KostOpbrengstEditPage} params={{ isNew: true, type: constants.KostOpbrengst.OPBRENGST }} />
					<Route path="opbrengstedit/:kostOpbrengstId" component={KostOpbrengstEditPage} params={{ isNew: false, type: constants.KostOpbrengst.OPBRENGST }} />
					<Route path="investeringen" component={InvesteringenPage} />
					<Route path="investeringedit/new" component={InvesteringEditPage} params={{ isNew: true }} />
					<Route path="investeringedit/:investeringId" component={InvesteringEditPage} params={{ isNew: false }} />
					<Route path="financiering" component={FinancieringPage} />
					<Route path="financieredit/new" component={FinancierEditPage} params={{ isNew: true }} />
					<Route path="financieredit/edit/:financierId" component={FinancierEditPage} params={{ isNew: false }} />
				</Route>

				<Route path="bovenlokaliteit/:dossierId">
					<IndexRoute component={BovenlokaliteitInfoPage} />
					<Route path="algemeen" component={BovenLokaliteitPerDossierPage} />
					<Route path="infrastructuur/:infrastructuurId" component={BovenLokaliteitPerInfrastructuurPage} />
					<Route path="edit/infraInDeBuurt/:infrastructuurId/:index" component={InfrastructuurInDeBuurtDetailPage} params={{ isNew: false }} />
					<Route path="add/infraInDeBuurt/:infrastructuurId" component={InfrastructuurInDeBuurtDetailPage} params={{ isNew: true }} />
				</Route>

				<Route path="beoordelingscriteriabovenlokaal/:dossierId" component={BeoordelingscriteriaBovenlokaalPage} />
				<Route path="beoordelingscriteriatopsport/:dossierId" component={BeoordelingscriteriaTopsportPage} />

				<Route path="indienen/bevestiging" component={IndienenBevestigingPage} />
				<Route path="indienen/:dossierId" component={IndienenPage} />

				<Route path="simulatiedossier/infra/:infrastructuurId/edit" component={SimulatieInfrastructuurDetailPage} params={{ isNew: false }} />
				<Route path="simulatiedossier/infra/:infrastructuurId/add/infraNieuwbouw" component={SimulatieInfrastructuurDetailPage} params={{ isNew: true, type: constants.INFRASTRUCTUUR_TYPE.NIEUWBOUW }} />
				<Route path="simulatiedossier/infra/:infrastructuurId/add/infraRenovatie" component={SimulatieInfrastructuurDetailPage} params={{ isNew: true, type: constants.INFRASTRUCTUUR_TYPE.RENOVATIE }} />

				<Route path="simulatiedossier/nieuw" component={SimulatieDossierPage} />
				<Route path="simulatiedossier/" component={SimulatieDossierPage} />
				<Route path="simulatiedossier" component={SimulatieDossierPage} />
				<Route path="simulatiedossier/:simulatieDossierId">
					<IndexRoute component={SimulatieDossierPage} />
					<Route path="algemeen" component={SimulatieDossierPage} />
					<Route path="infrastructuur/:infrastructuurId" component={SimulatiePerInfrastructuurPage} />
					<Route path="bevestiging" component={SimulatieBevestigingPage} />
				</Route>

				<Route path="voortgangsrapport/project/nieuw/:dossierId" component={VRProjectPage} params={{ isNew: true }} />
				<Route path="voortgangsrapport/project/:vrProjectId" component={VRProjectPage} params={{ isNew: false }} />
				<Route path="voortgangsrapport/beoordelingscriteria/:vrProjectId" component={VRBeoordelingscriteriaPage} params={{ isNew: false }} />
				<Route path="voortgangsrapport/verantwoording/:vrProjectId" component={VRVerantwoordingPage} params={{ isNew: false }} />
				<Route path="voortgangsrapport/indienen/:vrProjectId" component={VRIndienenPage} params={{ isNew: false }} />
				<Route path="voortgangsrapport/bevestiging" component={VRIndienenBevestigingPage} params={{ isNew: false }} />

				<Route path="afgesloten" component={AfgeslotenPage} />

				<Route path="testpage" component={TestPage} />
				<Route path="testpage/:id" component={TestPage} />
				<Route path="simulatiedossier/resultaat/:simulatieDossierId" component={SimulatieResultaatPage} />

				<Route path="*" component={NietGevondenPage} />

			</Route>
		</div >
	);
};
